








import ViewBase from '@/utils/ViewBase'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class Main extends ViewBase {
  @Prop( {
      type: Boolean,
      required: false,
      default: false
    }) visible: any
  @Prop( {
      type: Array,
      required: true,
      default: () => []
    }) itemList: any

  left = 0
  top = 0
  target = null
  selectedKeys = []

  get style() {
    return {
      left: this.left + 'px',
      top: this.top + 'px'
    }
  }

  created() {
    window.addEventListener('mousedown', e => this.closeMenu(e))
    window.addEventListener('contextmenu', e => this.setPosition(e))
  }

  closeMenu(e: any) {
    if (['menuitemicon', 'menuitem'].indexOf(e.target.getAttribute('role')) < 0) {
      this.$emit('update:visible', false)
    }
  }
  setPosition(e: any) {
    this.left = e.clientX
    this.top = e.clientY
    this.target = e.target
  }
  handleClick({key}: any) {
    this.$emit('select', key, this.target)
    this.$emit('update:visible', false)
  }
}
